<template>
    <div :style="{width, height}" class="statisDiv">
        <div class="headerClass">
            <div class="deparClass">部门名称</div>
            <!-- <div class="otherClass">所在地区</div> -->
            <div class="otherClass">负责区域</div>
            <div class="otherClass">销售总额</div>
            <div class="otherClass">订单总数</div>
            <div class="otherClass">客户总数</div>
        </div>
        <div class="departViewClass writeHearScroll">
            <div class="departItemClass" v-for="(item, index) in departArr" :key="index" @click="goDirector(item.dept_id)">
                <div class="deparClass whiteText">{{item.dept_name}}</div>
                <!-- <div class="otherClass whiteText">所在地区</div> -->
                <div class="otherClass whiteText">{{item.region_type_name}}</div>
                <div class="otherClass whiteText">{{convertUnit(item.sale_amount)}}</div>
                <div class="otherClass whiteText">{{item.order_num}}</div>
                <div class="otherClass whiteText">{{item.customer_num}}</div>
                <img class="userIconClass" src="../src/assets/imgs/userIcon.png" alt="">
            </div>
            <!-- <img class="noDataImgClass" v-if="imgShow" src="../src/assets/imgs/noDataImg.png" /> -->
        </div>
    </div>
</template>

<script>
export default {
    props: {
        width: String,
        height: String,
        backImg: String,
        totalText: String,
        companyName: String,
        describeText: String,
        departArr: Array,
    },
    data(){
        return{
            imgShow: false,
            showArr: []
        }
    },
    created(){
        let {departArr} = this
        departArr = []
        if(!departArr.length){
            this.imgShow = true
        }
    },
    methods: {
        goDirector(id){
            this.$emit('changeRole', id);
			this.$emit('changeRoleMobile',id)
        },
        convertUnit(money){
            let saleStr = money.replace(/,/g, '');
            let saleNumber = Number(saleStr)
            if(saleNumber == 0){
                return 0;
            }else{
                // 四舍五入并转换为带有“万”单位的字符串
                const roundedNum = Math.round(saleNumber / 10000 * Math.pow(10, 2)) / Math.pow(10, 2);
                let showText = roundedNum.toFixed(2) + 'w'
                return showText;
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.statisDiv{
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
	margin: auto;
}
.headerClass{
    display: flex;
    width: 100%;
    height: 26px;
}

.departViewClass{
    width: 100%;
    height: calc(100% - 30px);
    overflow-y: auto;
}
.departItemClass{
    margin-top: 8px;
    display: flex;
    width: 100%;
    min-height: 45px;
    max-height: 45px;
    background: linear-gradient(270deg, rgba(94,234,255,0) 0%, rgba(71,221,255,0.5) 49%, rgba(48,208,255,0) 100%);
    cursor: pointer;
}
.departItemClass:first-child{
    margin-top: 0;
}
.deparClass{
    display: flex;
    align-items: center;
    width: 20%;
    color: #13FFEE;
}
.otherClass{
    // max-width: 17%;
    // min-width: 15%;
    width: 15%;
    display: flex;
    align-items: center;
    color: #13FFEE;
}
.whiteText{
    font-weight: 500;
    font-size: 14px;
    color: #FFFFFF;
    cursor: pointer;
}
.totalDivClass{
    display: flex;
    align-items: center;
    background-color: #FFFFFF;
}
.totalClass{
    margin-top: 2%;
    font-weight: bold;
    color: #13FFEE;
    text-align: left;
    font-size: 22px;
}
.companyClass{
    font-weight: 600;
    font-size: 14px;
    color: #13FFEE;
    margin-top: 20px;
}
.describeClass{
    margin-top: -4px;
    color: #FFFFFF;
    font-size: 15px;
    text-align: left;
}
.userIconClass{
    margin: auto 0 auto 20px;
    width: 20px;
    height: 20px;
    background-size: 100% 100%;
}
.noDataImgClass{
    margin: 10% auto;
    width: 88px;
    height: 88px;
    background-size: 100% 100%;
}
</style>

<style lang="scss">
.writeHearScroll{
  &::-webkit-scrollbar {
    width: 6px;
    background: transparent;
  }

  &::-webkit-scrollbar-corner,
  /* 滚动条角落 */
  &::-webkit-scrollbar-thumb,
  &::-webkit-scrollbar-track {
    border-radius: 4px;
  }

  &::-webkit-scrollbar-corner,
  &::-webkit-scrollbar-track {
    /* 滚动条轨道 */
    background-color: #bfc7f3;
    box-shadow: inset 0 0 1px #e1e4f4;
  }

  &::-webkit-scrollbar-thumb {
    /* 滚动条手柄 */
    background-color: #797a7c;
  }
}
@media (max-width: 768px) {
	.deparClass{
		font-size: 10px !important;
		text-align: left;
	}
	.whiteText{
		font-size: 10px !important;
		align-items: left;
	}
	.otherClass{
		font-size: 10px !important;
		width: 18% !important;
		
	}
}
</style>